<div class="p-3">

  <!-- Tarjetas DB (siempre visibles) -->
  <div class="row mb-2 g-2">
    <div class="col-auto">
      <mat-card class="summary-card">
        <mat-card-content>
          <div class="summary-label">Total</div>
          <div class="summary-value">{{ resumen.total }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card summary-deployed">
        <mat-card-content>
          <div class="summary-label">Desplegadas</div>
          <div class="summary-value">{{ resumen.deployed }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card summary-undeployed">
        <mat-card-content>
          <div class="summary-label">Sin desplegar</div>
          <div class="summary-value">{{ resumen.undeployed }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card summary-failed">
        <mat-card-content>
          <div class="summary-label">Fallidas</div>
          <div class="summary-value">{{ resumen.deployFailed }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card summary-deploying">
        <mat-card-content>
          <div class="summary-label">Desplegando</div>
          <div class="summary-value">{{ resumen.deploying }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col d-flex align-items-center" *ngIf="resumen.syncTime">
      <span class="text-muted small">Sync DB: {{ resumen.syncTime | date:'HH:mm:ss' }}</span>
    </div>
  </div>

  <!-- Tarjetas de consumo MetaAPI (solo cuando están enriquecidas) -->
  <div class="row mb-3 g-2" *ngIf="apiStats">
    <div class="col-12">
      <div class="api-stats-header">
        <mat-icon class="api-stats-icon">cloud</mat-icon>
        <span>Estadísticas en vivo — MetaAPI Provisioning API</span>
        <span class="text-muted small ms-2" *ngIf="apiStats.syncTime">
          ({{ apiStats.syncTime | date:'HH:mm:ss' }})
        </span>
      </div>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-connected">
        <mat-card-content>
          <div class="summary-label">Conectadas</div>
          <div class="summary-value">{{ apiStats.connected }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-disconnected">
        <mat-card-content>
          <div class="summary-label">Desconectadas</div>
          <div class="summary-value">{{ apiStats.disconnected }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-broker">
        <mat-card-content>
          <div class="summary-label">Sin Broker</div>
          <div class="summary-value">{{ apiStats.disconnectedBroker }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-slots">
        <mat-card-content>
          <div class="summary-label">Resource Slots</div>
          <div class="summary-value">{{ apiStats.totalResourceSlots }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-cf">
        <mat-card-content>
          <div class="summary-label">CF Slots</div>
          <div class="summary-value">{{ apiStats.totalCfSlots }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-auto">
      <mat-card class="summary-card api-card-reliability">
        <mat-card-content>
          <div class="summary-label">High Reliability</div>
          <div class="summary-value">{{ apiStats.highReliability }}</div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Botones -->
  <div class="row mb-2">
    <div class="col-12 d-flex align-items-center gap-2 flex-wrap">
      <button mat-raised-button color="primary" (click)="cargar()" [disabled]="isLoading">
        <mat-icon>refresh</mat-icon>
        Recargar DB
      </button>
      <button mat-raised-button color="accent" (click)="enriquecer()"
              [disabled]="isEnriqueciendo || !dataSource.data.length">
        <mat-icon>cloud_download</mat-icon>
        {{ isEnriqueciendo ? 'Cargando...' : (enriquecido ? 'Actualizar MetaAPI' : 'Enriquecer desde MetaAPI') }}
      </button>
      <span class="text-muted small">Todas las cuentas MetaAPI registradas en el sistema.</span>
    </div>
  </div>

  <div *ngIf="isLoading || isEnriqueciendo" class="mb-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- Tabla -->
  <table mat-table [dataSource]="dataSource" class="w-100 metaapi-admin-table"
         *ngIf="dataSource.data.length">

    <ng-container matColumnDef="userId">
      <th mat-header-cell *matHeaderCellDef>User ID</th>
      <td mat-cell *matCellDef="let r">{{ r.userId }}</td>
    </ng-container>

    <ng-container matColumnDef="userEmail">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let r">{{ r.userEmail || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="mtLogin">
      <th mat-header-cell *matHeaderCellDef>MT Login</th>
      <td mat-cell *matCellDef="let r">{{ r.mtLogin }}</td>
    </ng-container>

    <ng-container matColumnDef="mtServer">
      <th mat-header-cell *matHeaderCellDef>MT Server</th>
      <td mat-cell *matCellDef="let r">{{ r.mtServer }}</td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let r">{{ r.nombre || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="origen">
      <th mat-header-cell *matHeaderCellDef>Origen</th>
      <td mat-cell *matCellDef="let r">{{ r.origen === 'GATEWAY' ? 'Gateway local' : 'MetaAPI' }}</td>
    </ng-container>

    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef>Región</th>
      <td mat-cell *matCellDef="let r">{{ r.region || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="estado">
      <th mat-header-cell *matHeaderCellDef>Estado DB</th>
      <td mat-cell *matCellDef="let r">
        <span class="estado-badge" [ngClass]="estadoClass(r.estado)">{{ r.estado }}</span>
      </td>
    </ng-container>

    <!-- Columnas enriquecidas (solo se muestran cuando está enriquecido) -->
    <ng-container matColumnDef="connectionStatus">
      <th mat-header-cell *matHeaderCellDef>Conexión</th>
      <td mat-cell *matCellDef="let r">
        <span *ngIf="r.connectionStatus" class="conn-badge" [ngClass]="connectionStatusClass(r.connectionStatus)"
              [matTooltip]="r.connectionStatus">
          <span class="conn-dot"></span>
          {{ r.connectionStatus === 'CONNECTED' ? 'Online' :
             r.connectionStatus === 'DISCONNECTED_FROM_BROKER' ? 'Sin Broker' : 'Offline' }}
        </span>
        <span *ngIf="!r.connectionStatus" class="text-muted">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="reliability">
      <th mat-header-cell *matHeaderCellDef>Reliability</th>
      <td mat-cell *matCellDef="let r">
        <span *ngIf="r.reliability" class="reliability-badge"
              [class.reliability-high]="r.reliability === 'high'">
          {{ r.reliability }}
        </span>
        <span *ngIf="!r.reliability" class="text-muted">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="resourceSlots">
      <th mat-header-cell *matHeaderCellDef>Slots</th>
      <td mat-cell *matCellDef="let r">
        <span *ngIf="r.resourceSlots != null" class="slots-badge"
              [matTooltip]="'CopyFactory: ' + (r.copyFactoryResourceSlots ?? 0)">
          {{ r.resourceSlots }}
          <span class="cf-slots" *ngIf="r.copyFactoryResourceSlots">+{{ r.copyFactoryResourceSlots }}CF</span>
        </span>
        <span *ngIf="r.resourceSlots == null" class="text-muted">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef>Plat.</th>
      <td mat-cell *matCellDef="let r">
        <span *ngIf="r.version" class="version-badge">MT{{ r.version }}</span>
        <span *ngIf="!r.version" class="text-muted">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Creada en MetaAPI</th>
      <td mat-cell *matCellDef="let r">
        {{ r.createdAt ? (r.createdAt | date:'yyyy-MM-dd') : '—' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="connections">
      <th mat-header-cell *matHeaderCellDef>Conex. activas</th>
      <td mat-cell *matCellDef="let r">
        <span *ngIf="r.connections != null">
          <span class="conn-count" [class.conn-count-active]="r.connections.length > 0">
            {{ r.connections.length }}
          </span>
          <span class="text-muted small" *ngIf="r.connections.length > 0">
            ({{ r.connections[0]?.region }}/{{ r.connections[0]?.zone }})
          </span>
        </span>
        <span *ngIf="r.connections == null" class="text-muted">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tokenExpiresAt">
      <th mat-header-cell *matHeaderCellDef>Vence token</th>
      <td mat-cell *matCellDef="let r"
          [class.text-danger]="isTokenExpired(r.tokenExpiresAt)"
          [class.text-warning]="isTokenExpiringSoon(r.tokenExpiresAt)">
        {{ r.tokenExpiresAt ? (r.tokenExpiresAt | date:'dd/MM/yyyy') : '—' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastActive">
      <th mat-header-cell *matHeaderCellDef>Última actividad</th>
      <td mat-cell *matCellDef="let r">{{ r.lastActive | date:'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="metaApiAccountId">
      <th mat-header-cell *matHeaderCellDef>Account ID</th>
      <td mat-cell *matCellDef="let r" class="account-id-cell">
        <span class="account-id-truncated" [matTooltip]="r.metaApiAccountId">
          {{ r.metaApiAccountId | slice:0:8 }}…
        </span>
        <button mat-icon-button class="copy-btn"
                (click)="copyToClipboard(r.metaApiAccountId)"
                matTooltip="Copiar ID completo">
          <mat-icon>content_copy</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let r" class="acciones-cell">

        <!-- Deploy -->
        <button mat-icon-button color="primary"
                *ngIf="canDeploy(r.estado) && r.origen !== 'GATEWAY'"
                [disabled]="isDeploying[r.metaApiAccountId]"
                (click)="deployar(r.metaApiAccountId)"
                matTooltip="Deploy — conectar cuenta a MetaAPI">
          <mat-icon>play_circle</mat-icon>
        </button>

        <!-- Undeploy -->
        <button mat-icon-button color="warn"
                *ngIf="canUndeploy(r.estado) && r.origen !== 'GATEWAY'"
                [disabled]="isDeploying[r.metaApiAccountId]"
                (click)="undeploy(r.metaApiAccountId)"
                matTooltip="Undeploy — desconectar cuenta">
          <mat-icon>stop_circle</mat-icon>
        </button>

        <!-- Eliminar en MetaAPI -->
        <button mat-icon-button color="warn"
                *ngIf="canDelete(r.estado)"
                [disabled]="isDeploying[r.metaApiAccountId] || isTransitioning(r.estado)"
                (click)="eliminar(r)"
                matTooltip="Eliminar cuenta en MetaAPI (irreversible)">
          <mat-icon>delete_forever</mat-icon>
        </button>

        <!-- Transitioning spinner -->
        <mat-spinner *ngIf="isTransitioning(r.estado)"
                     diameter="20" class="inline-spinner">
        </mat-spinner>

        <!-- Sync -->
        <button mat-icon-button color="accent"
                *ngIf="r.estado !== 'REMOVED' && r.origen !== 'GATEWAY'"
                (click)="syncCuenta(r.metaApiAccountId)"
                [disabled]="isSyncing[r.metaApiAccountId]"
                matTooltip="Sincronizar estado desde MetaAPI">
          <mat-icon>sync</mat-icon>
        </button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnas"></tr>
    <tr mat-row *matRowDef="let row; columns: columnas"></tr>
  </table>

  <div *ngIf="!isLoading && !dataSource.data.length" class="text-muted mt-2">
    No hay cuentas MetaAPI registradas.
  </div>

</div>
